import React from 'react';
import PropTypes from 'prop-types';

import ViewDraftjsText from '../../../ViewDraftjsText/ViewDraftjsText';


function PrivateContentDescription(props) {
  const {
    shouldShowDescription,
    media,
    title,
    leftTitle,
    allAnchors,
  } = props;
  if (!shouldShowDescription) {
    return null;
  }

  return (
    <div className="content-item-caption private-video-caption">
      <div className="content-item-title private-video-title" title={title}>
        <ViewDraftjsText
          allAnchors={allAnchors}
          metadata={media?.titleMetadata}
          text={title}
        />
      </div>
      <div className="private-video-desc">
        <span className="private-gallery-image-count">{leftTitle}</span>
        <span className="anchor-name" title={media?.anchorName}>{media?.anchorName}</span>
      </div>
    </div>
  );
}

export default PrivateContentDescription;

PrivateContentDescription.propTypes = {
  shouldShowDescription: PropTypes.bool,
  media: PropTypes.object.isRequired,
  title: PropTypes.string,
  leftTitle: PropTypes.string,
};

